var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavMenuLinkRidmFull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14 18c.552 0 1 .448 1 1v11c0 .552-.448 1-1 1H3c-.552 0-1-.448-1-1V19c0-.552.448-1 1-1h11zm12.901-1L31 21.099V26.9L26.901 31H21.1L17 26.901V21.1L21.099 17H26.9zM8.5 1C12.642 1 16 4.358 16 8.5c0 4.142-3.358 7.5-7.5 7.5C4.358 16 1 12.642 1 8.5 1 4.358 4.358 1 8.5 1zm21.784.028c.552 0 1 .448 1 1 0 .173-.045.343-.13.493L24.37 14.493c-.272.48-.882.65-1.363.377-.157-.09-.288-.22-.377-.377L15.846 2.52c-.272-.48-.103-1.09.377-1.363.15-.085.32-.13.493-.13h13.568z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMenuLinkRidmFull);
export default __webpack_public_path__ + "static/media/nav-menu-link-ridm-full.7213bbb67a1f5858805f4911529502b8.svg";
export { ForwardRef as ReactComponent };